<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="page-title-box d-flex align-items-center justify-content-between">
                <h4 class="font-size-24 d-flex align-items-center">
                    Notifications
                </h4>
                <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                        <li class="breadcrumb-item"><a href="javascript: void(0);">Lemur Maritime</a></li>

                        <li class="breadcrumb-item active">Notifications </li>

                    </ol>
                </div>
            </div>
        </div>
    </div>

    <div class="row mb-md-2 justify-content-end">
        <div class="col-sm-12 col-md-7 mb-2 userlistSelectSection">
            <div role="group" aria-label="Basic example" class="input-group ">
                <ng-select [items]="moduleData" placeholder="Module" class="form-control p-0" [(ngModel)]="filters.Module" (change)="OnPerPageChange()"></ng-select>
                <ng-select [items]="comapanyData" placeholder="Company" class="form-control p-0" bindLabel="name" bindValue="id" [(ngModel)]="filters.Company" (change)="OnPerPageChange()"></ng-select>
                <ng-select style="min-width: 200px;" [items]="actionData" bindValue="fullString" bindLabel="fullString" class="form-control p-0" placeholder="Action" [(ngModel)]="filters.moduleId" (change)="OnPerPageChange()"></ng-select>
                <input placeholder="Select Date" type="text" name="customDateRangPicker" class="form-control" [(ngModel)]="filterDate" (change)="OnPerPageChange()">
                <input type="button" hidden="true" class="form-control" id="HidenCustDate" (click)="onDateFilterApply()">

                <!-- <ng-select placeholder="Select Activity" id="activity" >
                </ng-select>
                <ng-select placeholder="Select Company" id="activity" >
                </ng-select> -->
                <button type="button" class="btn btn-primary" (click)="clearFilter()">
          <i class="bx bx-menu-alt-right"></i>
        </button>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                    <div class="row mb-md-2">
                        <div class="table-responsive">
                            <table class="table align-middle">
                                <thead>
                                    <tr>
                                        <th>Module</th>
                                        <th>Action</th>
                                        <th>Description</th>
                                        <th>Created Date</th>
                                        <th>Click Here</th>
                                    </tr>
                                </thead>
                                <thead>
                                    <tr class="align-top" *ngFor="let items of notificationData | paginate: {itemsPerPage: pageConfig.perPage,currentPage: pageConfig.curPage,totalItems: total,id: 'first'};let i = index">
                                        <td>{{items.moduleEnum}}</td>
                                        <td [ngStyle]="{'color': getColor(items.moduleId)}">{{items.moduleId}}</td>
                                        <td>{{items.text}}</td>
                                        <td style="width: 100px;">{{items.createdAt | date:'YYYY-MM-dd'}}</td>
                                        <td>
                                            <a [href]="items.href">{{items.href}}</a>
                                        </td>
                                    </tr>

                                </thead>
                            </table>

                            <!-- <a href="javascript: void(0);" class="text-reset notification-item">
                            <div class="media">
                                <div class="avatar-xs me-3">
                                    <span class="avatar-title bg-primary rounded-circle font-size-16">
                                        <i class="bx bx-cart"></i>
                                    </span>
                                </div>
                                <div class="media-body">
                                    <h5 class="mt-0 mb-1" font-18>Your order is placed</h5>
                                    <div class="font-size-12 text-muted">
                                        <p class="mb-1 font-16">If several languages coalesce the grammar</p>
                                        <p class="mb-0"><i class="mdi mdi-clock-outline"></i>
                                            3 min ago</p>
                                    </div>
                                </div>
                            </div>
                        </a>
                        <a href="javascript: void(0);" class="text-reset notification-item">
                            <div class="media">
                                <div class="avatar-xs me-3"><span
                                        class="avatar-title bg-success rounded-circle font-size-16"><i
                                            class="bx bx-badge-check"></i></span></div>
                                <div class="media-body">
                                    <h5 class="mt-0 mb-1" font-18>Your item is shipped</h5>
                                    <div class="font-size-12 text-muted">
                                        <p class="mb-1 font-16">If several languages coalesce the grammar
                                        </p>
                                        <p class="mb-0"><i class="mdi mdi-clock-outline"></i>3 min ago</p>
                                    </div>
                                </div>
                            </div>
                        </a>
                        <a href="javascript: void(0);" class="text-reset notification-item">
                            <div class="media"><img src="../../../../assets/images/logo_dark.png" alt="user-pic"
                                    class="me-3 rounded-circle avatar-xs">
                                <div class="media-body">
                                    <h5 class="mt-0 mb-1 font-18">Salena Layfield</h5>
                                    <div class="font-size-12 text-muted">
                                        <p class="mb-1 font-16">As a skeptical Cambridge friend of mine
                                            occidental.</p>
                                        <p class="mb-0"><i class="mdi mdi-clock-outline"></i>1 hours ago</p>
                                    </div>
                                </div>
                            </div>
                        </a> -->
                        </div>
                        <div class="row justify-content-md-between align-items-md-center mt-2" *ngIf="notificationData?.length > 0">
                            <div class="col-sm-12 col-md-5">
                                <div id="tickets-table_info " role="status " aria-live="polite " class="dataTables_info mb-2">
                                    Showing 1 of {{total}} Entries
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-5">
                                <div class=" mt-4">
                                    <pagination-controls class="pagination paging justify-content-center float-end" (pageChange)="onGetPage($event)" id="first">
                                    </pagination-controls>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="notificationData?.length==0">
                            <h5 class="text-danger text-center">No Record Found</h5>
                        </div>
                    </div>
                </div>
            </div>
